import { render, staticRenderFns } from "./ShoppingBasket.vue?vue&type=template&id=20c57cbc&scoped=true&"
import script from "./ShoppingBasket.vue?vue&type=script&lang=js&"
export * from "./ShoppingBasket.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingBasket.vue?vue&type=style&index=0&id=20c57cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c57cbc",
  null
  
)

export default component.exports